module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_en-4cf37312e08abf7ff37e225d4f5cc98f.gif";